import { useEffect, useState } from "react";

// Wall-clock time that re-renders the caller on a fixed cadence. Pass null to
// hold still — a row with nothing left to count shouldn't own an interval.
export function useNow(intervalMs: number | null): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (intervalMs == null) return;

    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
